import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const LearningContentCompletedMessage = ({
  type
}) => {
  switch (type) {
    case 'SHORT_FORM_CONTENT':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.shortContent.watched"
      });
    default:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.completedIcontext"
      });
  }
};